import React from "react";
import Calendar from "rc-calendar";
import DatePicker from "rc-calendar/lib/Picker";
import RangeCalendar from "rc-calendar/lib/RangeCalendar";
import moment from "moment";
import "rc-calendar/assets/index.css";
import "./index.css";

const defaultFormat = "DD-MM-YYYY";

function disabledDate(current) {
    if (!current) return false;
    return current.isBefore(moment().startOf("day"));
}

/* ================= SINGLE DATE PICKER ================= */

const DateTimePicker = (props) => {
    const {value = null, onChange, format = defaultFormat, item = {}} = props;
    const {
        placeholder = "Please select Date",
        disabled = false,
        disablePreviousDate = false,
    } = item;

    const calendar = (
        <Calendar
            showClear={false}
            format={format}
            disabledDate={disablePreviousDate ? disabledDate : null}
        />
    );

    return (
        <DatePicker
            calendar={calendar}
            value={value}
            onChange={onChange}
            disabled={disabled}
        >
            {({value}) => (
                <span tabIndex="0">
                    <input
                        className="form-control"
                        readOnly
                        tabIndex="-1"
                        placeholder={placeholder}
                        value={value ? value.format(format) : ""}
                    />
                </span>
            )}
        </DatePicker>
    );
};

/* ================= RANGE DATE PICKER ================= */

const RangePicker = (props) => {
    const {value = [], onChange, format = defaultFormat, item = {}, ranges = null, customStyle = {}} = props;
    const {
        placeholder = ["Start Date", "End Date"],
        disabled = false,
        disablePreviousDate = false,
    } = item;

    const calendar = (
        <RangeCalendar
            format={format}
            disabledDate={disablePreviousDate ? disabledDate : null}
            renderFooter={() => (
                ranges ? <div className="rc-range-presets">
                    {Object.keys(ranges).map((label) => (
                        <a key={label}
                           className={'btn btn-default'}
                           onClick={() => onChange(ranges[label])}>
                            {label}
                        </a>
                    ))}
                </div> : null
            )}
        />
    );

    return (
        <DatePicker
            calendar={calendar}
            value={value}
            onChange={onChange}
            disabled={disabled}
        >
            {({value = []}) => (
                <span tabIndex="0">
                    <input
                        className="form-control"
                        style={{...customStyle, height: "37px!important"}}
                        readOnly
                        tabIndex="-1"
                        placeholder={`${placeholder[0]} - ${placeholder[1]}`}
                        value={
                            value.length === 2
                                ? `${value[0].format(format)} - ${value[1].format(format)}`
                                : ""
                        }
                    />
                </span>
            )}
        </DatePicker>
    );
};

DateTimePicker.RangePicker = RangePicker;

export default DateTimePicker;
